<template>
	<v-container grid-list-md text-xs-right>
		<v-form ref="form" class="xs12">
			<v-layout row wrap>
				<template>
					<v-flex xs12 md6>
						<v-select
							light lazy filled v-model="userDetail.group" :items="groups"
							item-text="name" item-value="_id" :label="$t('users.table.group')"
						></v-select>
					</v-flex>
					<v-flex xs12 md6>
						<v-select
							light lazy filled multiple v-model="userDetail.roles" :items="roles"
							item-text="name" item-value="_id" :label="$t('users.table.role')"
						></v-select>
					</v-flex>
				</template>
			</v-layout>
		</v-form>
		<v-btn color="primary"
			   :loading="isSaving"
			   @click="save()">
			{{ $t('save') }}
		</v-btn>

    <v-btn color="error"
           class="danger-button"
           @click="remove()">
      {{ $t('remove') }}
    </v-btn>
	</v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'UsersTableItem',
	components: {},
	props: {
		user: {
			type: Object,
		}
	},
	data() {
		return {
			showConfirmDeleteDialog: false,
			userDetail: {}
		};
	},
	computed: {
		...mapState({
			isSaving: state => state.user.isSavingUser,
			roles: state => state.role.roles,
			groups: state => state.group.groups,
		}),
	},
	mounted() {
		this.userDetail = JSON.parse(JSON.stringify(this.user));
	},
	methods: {
		save() {
			this.$emit('updateUser', this.userDetail);
		},
		remove() {
			this.$emit('removeUser', this.userDetail);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

.cards {
	background-color: $background-grey !important;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 250px;
	height: 250px;
	margin: 10px;
	text-align: center;

	&:hover {
		background-color: $light-grey !important;
	}
}

.danger-button{
  margin-left: .5rem;
}
</style>
